<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';

export default {
    init: async (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
        
         setTimeout(async function(){
            let respManufacturers = (await Request.do(payload, 'POST', Request.getDefaultHeader(payload), {type:"TRUCK"}, `${Endpoints.parts.manufacturer.listByType}`)).data;
            if (respManufacturers.status==200){
                payload.manufacturers = respManufacturers.results;
            }
        }, 100);
        
    },
    methods:{
        filter: function(){
            let payload = this;
            
            setTimeout(async function(){
                
                let truck = (await Request.do(payload, 'POST', Request.getDefaultHeader(payload), payload.filters, 
                    `${Endpoints.trucks.listByType}`));
                
                if (truck.status==200){
                    payload.items = truck.data.results;
                }
            }, 100);
        },
        selectItem: function(item){
            let copy = JSON.parse(JSON.stringify(item));
            
            if(copy.actualKM){
                copy.actualKM = Number(copy.actualKM)
            }

            if(copy.manufacturer && copy.manufacturer._id){
                copy.manufacturer = copy.manufacturer._id;
            }

            if(copy.model && copy.model._id){
                copy.model = copy.model._id;
            }

            if(copy.truckDriver && copy.truckDriver._id){
                copy.truckDriver = copy.truckDriver._id;
            }
            
            copy.oldDocumentPhotoURL = copy.documentPhotoURL;
            this.$emit('load-item', copy);
        },
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase
    }
}
</script>
